module.exports = __webpack_public_path__ + "static/media/sombra-lateral-livro-todo.2ebbac9f.svg";